import request from '@/utils/request'

export function loginByUsername(username, password) {
  const data = {
    username: username,
    password: password,
    remember: 365
  }
  return request({
    url: process.env.BJH_API + '/api/content/pc/Login.json',
    method: 'post',
    data: data
  })
}

export function getMyRoles() {
  return request({
    url: process.env.BJH_API + '/api/content/pc/GetMyRole.json',
    method: 'get'
  })
}

export function logout() {
  return request({
    url: process.env.BJH_API + '/api/content/pc/Logout.json',
    method: 'post'
  })
}
